// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IGl0h4tRHT8fww_OQa8a {
  display: flex;
  flex-direction: row;
  gap: 8px;
  max-width: 630px;
  padding: 16px;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid var(--orange-color-500);
  background-color: var(--grey-color-10);
  box-shadow: 0 -1px 2px 0 rgba(15, 20, 31, 0.12), 0 4px 16px 0 rgba(15, 20, 31, 0.16);
}

.ZrOA31vXaZ_TCAYF00f5 {
  margin-top: 4px;
}

.JxSAVRtJwk9NdNkkw2_l {
  width: 515px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.UIIB2NTh2yD88ZNnJJTX {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
}

.E9p0tOXJJ0k67zEKC4Uo {
  margin: 4px 0 4px 16px;
  padding: 0;
  list-style-type: disc;
}
.E9p0tOXJJ0k67zEKC4Uo li {
  margin-bottom: 4px;
}
.E9p0tOXJJ0k67zEKC4Uo li:last-child {
  margin-bottom: 0;
}
.E9p0tOXJJ0k67zEKC4Uo li strong {
  font-family: var(--font-stack-full-heavy);
}

.drVWX8qpFalP6qcdyGwF {
  margin-top: 12px;
}

.z1BxDSZrvDYIjajRl0W8 {
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/CautionCard/CautionCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,sCAAA;EACA,oFAAA;AACF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;AAAF;;AAGA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,UAAA;EACA,qBAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,yCAAA;AADN;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF","sourcesContent":[".cautionCard {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  max-width: 630px;\n  padding: 16px;\n  align-self: stretch;\n  border-radius: 20px;\n  border: 1px solid var(--orange-color-500);\n  background-color: var(--grey-color-10);\n  box-shadow: 0 -1px 2px 0 rgba(15, 20, 31, 0.12),\n    0 4px 16px 0 rgba(15, 20, 31, 0.16);\n}\n\n.warningSign {\n  margin-top: 4px;\n}\n\n.content {\n  width: 515px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.cautionDescription {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px;\n}\n\n.cautionList {\n  margin: 4px 0 4px 16px;\n  padding: 0;\n  list-style-type: disc;\n\n  li {\n    margin-bottom: 4px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    strong {\n      font-family: var(--font-stack-full-heavy);\n    }\n  }\n}\n\n.checkboxContainer {\n  margin-top: 12px;\n}\n\n.errorContainer {\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cautionCard": `IGl0h4tRHT8fww_OQa8a`,
	"warningSign": `ZrOA31vXaZ_TCAYF00f5`,
	"content": `JxSAVRtJwk9NdNkkw2_l`,
	"cautionDescription": `UIIB2NTh2yD88ZNnJJTX`,
	"cautionList": `E9p0tOXJJ0k67zEKC4Uo`,
	"checkboxContainer": `drVWX8qpFalP6qcdyGwF`,
	"errorContainer": `z1BxDSZrvDYIjajRl0W8`
};
export default ___CSS_LOADER_EXPORT___;
